const PREFIX = process.env.VUE_APP_PREFIX
const TOKEN = 'e2f26454b4356f07cb6f039ba52cce35bb676fa14125bf572b32e241f7247e6bb02f1f57c035bc6bb51fd9bc5d669bb8f0af9a5c7853bbd32af39b759d4c3cc5.dVv3fX5HkSmzKs+z2nTVC47x0Nvc40bOHs1CJPCO2g0'

export const KINDEREDU_PORTAL_TOKEN = `${PREFIX}:${TOKEN}`
export const DADATA_TOKEN = 'a8f8ddccd84ee7750d686fd35061ca4d611f8745'
